import typography from '@material-ui/core/Typography';
import { grey } from '@material-ui/core/colors';

import bgProfile from './images/material_bg.png';

const styles = {
  tableList: {
    height: '60vh',
  },
  textField: {
    marginTop: 20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 20,
    width: '70%',
  },
  modal: {
    fullscreen: {
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    fullWidth: {
      width: '98%',
      maxWidth: 'none',
    },
    content: {
      minHeight: 600,
    },
  },
  navigation: {
    fontSize: 15,
    fontWeight: typography.fontWeightLight,
    color: grey[600],
    paddingBottom: 30,
    display: 'block',
  },
  pagination: {
    margin: 2,
  },
  title: {
    fontSize: 20,
    fontWeight: typography.fontWeightLight,
    marginBottom: 5,
  },
  toolbarTitle: {
    marginLeft: 30,
  },
  paper: {
    padding: 30,
    display: 'table',
    width: '100%',
  },
  clear: {
    clear: 'both',
  },
  floatingActionButton: {
    margin: 0,
    top: 125,
    left: 'auto',
    right: 25,
    position: 'fixed',
  },
  bgProfile,
  logoLife: {
    height: 200,
    width: 400,
  },
  loginContainer: {
    width: 450,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  bottomButton: {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
  },
  secondBottomButton: {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 80,
    left: 'auto',
    position: 'fixed',
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/styles.js